import React, { Component } from 'react';
import { connect } from 'react-redux';
import SidebarList from 'features/Admin/components/SidebarList';
import ElementFocus from 'features/Admin/components/ElementFocus';
import {
	adminGetContactComment,
	adminGetAllContactComments,
	resetFocusContactComment,
	initNewContactComment,
	adminPatchContactComment,
	adminPostContactComment,
	adminDeleteContactComment,
} from 'services/contactComment';
import AdminDataContainer from 'features/Admin/components/AdminDataContainer';
import { Grid, Icon } from 'semantic-ui-react';
import RedButton from 'components/Buttons/RedButton';
import GeneralForm from 'features/Admin/ContactComments/Forms/GeneralForm';
import { Form, Formik } from 'formik';
import MainButton from 'components/Buttons/MainButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import * as Yup from 'yup';

const schemaValidation = Yup.object().shape({
	label: Yup.string().required('Champ requis'),
	order: Yup.number().required('Champ requis'),
});

class ContactCommentsAdmin extends Component {
	componentDidMount() {
		this.getAllElements();
	}

	componentWillUnmount() {
		this.props.resetFocusContactComment();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {}

	getAllElements = () => {
		this.props.adminGetAllContactComments();
	};

	focusOnElement = (elt) => {
		this.props.adminGetContactComment(elt);
	};

	onAddClick = () => {
		this.props.initNewContactComment();
	};

	saveFocus = (values, setSubmitting) => {
		if (values.id === undefined) {
			delete values.id;
			this.props.adminPostContactComment(values).then(() => {
				setSubmitting(false);
			});
		} else {
			this.props.adminPatchContactComment(values).then(() => {
				setSubmitting(false);
			});
		}
	};

	deleteFocus = () => {
		this.props.adminDeleteContactComment(
			this.props.contactComments.focus.data
		);
	};

	render() {
		const { contactComments } = this.props;
		const { focus, list } = contactComments;
		const contactComment = focus.data;
		const newContactComment =
			contactComment !== null && contactComment.id === undefined;

		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={contactComments.list}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity="Commentaire contact"
					addButtonText="Nouveau Commentaire contact"
					onAddButtonClick={this.onAddClick}
					defaultLabel={(e) => e.label}
					groupField={false}
					focusedEltId={contactComment}
				/>

				<ElementFocus
					element={focus}
					list={list}
					entity="Commentaire contact"
					icon='info'
				>
					{contactComment !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: contactComment.id,
								label: contactComment.label || '',
								order: contactComment.order || 1,
							}}
							validationSchema={schemaValidation}
							onSubmit={(values, { setSubmitting }) => {
								this.saveFocus(values, setSubmitting);
							}}
						>
							{({ isSubmitting, errors }) => (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<SecondaryButton
													type='button'
													style={{ float: 'left' }}
													onClick={this.props.resetFocusContactComment}
												>
													Fermer
												</SecondaryButton>
												<MainButton
													text={<Icon name='save' />}
													type='submit'
													style={{ float: 'left' }}
													isSubmitting={isSubmitting}
													disabled={
														Object.entries(errors).length > 0 &&
														errors.constructor === Object
													}
												>
													{newContactComment ? 'Créer' : 'Enregistrer'}
												</MainButton>

												{!newContactComment && (
													<RedButton
														text={<Icon name='trash' />}
														type='button'
														onClick={(e) => {
															if (e !== undefined) e.preventDefault();
															this.deleteFocus();
														}}
														style={{ float: 'right' }}
													>
														Supprimer
													</RedButton>
												)}
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={1}>
											<Grid.Column>
												<AdminDataContainer
													ribbonColor='red'
													ribbonLabel='Général'
												>
													<GeneralForm />
												</AdminDataContainer>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							)}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: '100%',
		width: '100%',
		paddingTop: 43,
		fontSize: 0,
		display: 'flex',
	},
	blocHeader: {
		backgroundColor: 'rgb(0, 147, 128)',
		padding: 10,
		width: '100%',
		borderRadius: '4px 4px 0 0',
	},
};

const mapStateToProps = (state) => {
	return {
		contactComments: state.admin.contactComments,
	};
};

const mapDispatchToProps = {
	adminGetAllContactComments,
	adminGetContactComment,
	adminPatchContactComment,
	adminDeleteContactComment,
	resetFocusContactComment,
	adminPostContactComment,
	initNewContactComment,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ContactCommentsAdmin);
